import dailyReportInputRules from '@/configs/dailyReportInputRules.json'
export const INPUT_RULES = dailyReportInputRules
